export default "__VITE_ASSET__hi3XV1aG__"